module.exports = __webpack_public_path__ + "img/bg-mhyc.64893b2f.png";